import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'

import { venueInventoryDtoSchema, type VenueInventoryDto } from '@lib/dto/venue-inventory.dto'
import type { SetInventoryLineInput } from '@lib/input/venue-inventory.input'

/** Service for a venue's base furniture inventory (venue-wide + per-space stock). */
class InventoryService {
  async getForVenue(venueId: string): Promise<VenueInventoryDto> {
    try {
      return await api.get(`/venues/${venueId}/inventory`, venueInventoryDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to load venue inventory', { venueId }, error)
      throw error
    }
  }

  /** Set one inventory line (movable pool or one space); quantity 0 removes it. */
  async setLine(venueId: string, input: SetInventoryLineInput): Promise<VenueInventoryDto> {
    try {
      return await api.put(`/venues/${venueId}/inventory/line`, input, venueInventoryDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to set venue inventory line', { venueId }, error)
      throw error
    }
  }
}

export const inventoryService = new InventoryService()
